export default "/images/vendor/flag-icons/flags/1x1/ai.svg?99ad0ab376cc53caf4ae5e432d92fe9c";